import SSRIcon from '@ingka/ssr-icon';
import arrowOnPath from '@ingka/ssr-icon/paths/arrow-on-path';
import checkmark from '@ingka/ssr-icon/paths/checkmark';
import warningTriangle from '@ingka/ssr-icon/paths/warning-triangle';
import { isOrderStatus, orderStatuses } from '@repo/types/order';

import { formatIconName } from '@/utils/services.utils';

interface Props {
    orderStatus: string;
}

const statusIcons = {
    [orderStatuses.Completed]: checkmark,
    [orderStatuses.HasAnIssue]: warningTriangle,
    [orderStatuses.NotFound]: warningTriangle,
    [orderStatuses.InProgress]: arrowOnPath,
    [orderStatuses.Booked]: arrowOnPath,
} as const;

export const ArticleDeliveryStatusIcon = ({ orderStatus }: Props) => {
    const iconPath = isOrderStatus(orderStatus) ? statusIcons[orderStatus] : warningTriangle;

    const testIdString = formatIconName(iconPath.name);

    const testId = `delivery-icon-${testIdString}`;

    return <SSRIcon paths={iconPath} data-testid={testId} />;
};
